import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=2f797044&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f797044')) {
      api.createRecord('2f797044', component.options)
    } else {
      api.reload('2f797044', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=2f797044&", function () {
      api.rerender('2f797044', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/baseInformation/unitManager/detail.vue"
export default component.exports